// extracted by mini-css-extract-plugin
export var button = "_tb-1";
export var container = "_tb-0";